<template>
  <v-row justify="center">
    <v-dialog
        v-model="dialog"
        width="1250px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            text
            color="grey darken-1"
            v-bind="attrs"
            v-on="on"
            @click="updateOptions"
            x-small
            class="mt-1 mb-3 ml-n6 py-0"
        >
          <div>
            <span v-if="date_day != null" class="text-left my-0 px-0 py-0">{{ date_day | moment("DD.MM.YYYY") }}</span>
            <span v-else>
              <v-icon color="blue">
                mdi-alert-circle-outline
              </v-icon>
            </span>
          </div>
        </v-btn>
      </template>
      <v-data-table
          dense
          :headers="getColumns"
          :items="itemList"
          item-key="id"
          class="elevation-1"
          :options.sync="options"
          @update:options="updateOptions"
          :server-items-length="totalRecords"
          :loading="loading"
          :footer-props="{
          'items-per-page-options': [10, 15, 20, 50, 100]
        }"
          :height="windowHeight"
          fixed-header
          ref="left_table"
      >
        <template v-slot:top>
          <v-toolbar dense class="mt-2 pt-1 mb-2" elevation="1" color="gridtoolbar">
            <v-text-field
                dark
                v-model="searchTerm"
                label="Search"
                class="mx-4"
                clearable
                @input="onUpdateSearchTerm"
            ></v-text-field>
          </v-toolbar>
        </template>
        <template v-slot:item.notion_id="{ item }">
          <v-row>
            <v-icon
                v-if="item.notion_id != null"
                color="primary"
                size="20"
                @click="onNotion(item)"
            >
              mdi-alpha-n-box-outline
            </v-icon>
          </v-row>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row>
          <span>
            <BatchRunBadge
                :item="item"
                :draggable="false"
                :content="item.number"
            />
          </span>
          </v-row>
        </template>
        <template v-slot:item.delivery_date="{ item }">
          <span v-if="item.delivery_date != null">
            {{ item.delivery_date | moment("DD.MM.YYYY") }}
          </span>
        </template>
        <template v-slot:item.smd_start_plan="{ item }">
          <span v-if="item.smd_start_plan != null">
            {{ item.smd_start_plan | moment("DD.MM.YYYY") }}-{{ item.smd_end_plan | moment("DD.MM.YYYY") }}
          </span>
        </template>
        <template v-slot:item.tht_start_plan="{ item }">
          <span v-if="item.tht_start_plan != null">
            {{ item.tht_start_plan | moment("DD.MM.YYYY") }}-{{ item.tht_end_plan | moment("DD.MM.YYYY") }}
          </span>
        </template>
        <template v-slot:item.smd="{ item }">
          {{ Math.round(item.smd) }}
        </template>
        <template v-slot:item.tht="{ item }">
          {{ Math.round(item.tht) }}
        </template>

        <template v-slot:body.append="{headers}">
          <tr>
            <td v-for="(header,i) in headers" :key="i">

              <div v-if="header.value == 'smd'">
                {{ getSMDSum }}
              </div>

              <div v-if="header.value == 'tht'">
                {{ getTHTSum }}
              </div>

              <div v-else>
                <!-- empty table cells for columns that don't need a sum -->
              </div>
            </td>
          </tr>
        </template>

      </v-data-table>

    </v-dialog>
  </v-row>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import BaseDeleteDialog from "@/components/BaseDeleteDialog";
import BaseTaskProgress from "@/components/BaseTaskProgress"
import BaseModal from "@/components/Base/BaseModal";
import BatchRunBadge from "@/components/BatchRun/BatchRunBadge"

export default {
  name: 'BatchRunListDialog',
  props: {
    'subheight': {type: [Number], default: 200},
    'year_week_id': {type: [Number]},
    'week_day': {type: [String], default: null},
    'date_day': {type: [String], default: null},
  },

  components: {
    BatchRunBadge,
  },

  computed: {
    ...mapGetters('BatchRunDialog', ['getColumns']),
    ...mapFields('BatchRunDialog', ['options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm', 'isAlive', 'filters']),
    getSMDSum() {
      return Math.round(this.itemList.reduce((partialSum, item) => partialSum + item.smd, 0))
    },
    getTHTSum() {
      return Math.round(this.itemList.reduce((partialSum, item) => partialSum + item.tht, 0))
    },
  },

  methods: {
    ...mapActions('BatchRunDialog', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems']),
    onResize() {
      this.windowHeight = (window.innerHeight - this.subheight) + 'px'
    },
    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm')
      this.options.page = 1
      this.filters['year_week_id'] = this.year_week_id
      this.filters['week_day'] = this.week_day
      this.fetchItemList()
    }, 800),

    updateOptions() {
      // console.log('updateOptions')
      this.filters['year_week_id'] = this.year_week_id
      this.filters['week_day'] = this.week_day
      this.fetchItemList()
    },
    getItemColor(item) {
      if (item.smd > 0 && item.tht > 0)
        return 'purple'
      if (item.tht > 0)
        return 'blue'
      return 'orange'
    },
    onNotion(item) {
      // console.log('onNotion', item)
      window.open('https://www.notion.so/' + item.notion_id.replace(/-/g, ''), '_blank')
    },
  },

  async mounted() {
    // console.log('mounted')
    window.addEventListener("resize", this.onResize);
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  data() {
    return {
      windowHeight: (window.innerHeight - this.subheight) + 'px',
      dialog: false,
    }
  }
}
</script>

<style scoped lang="scss">
</style>
